<template>
  <v-card color="grey lighten-3">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{spoil.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="close()">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container>
      <v-layout row wrap justify-center>
        <v-flex xs12 md8>
          <v-subheader class="pl-0">{{pageName}} Details</v-subheader>
          <v-card>
            <top-right-absolute>
              <v-btn flat icon color="grey" @click="edit = true">
                <v-icon>edit</v-icon>
              </v-btn>
            </top-right-absolute>

            <layout-no-padding>
              <v-flex xs6>
                <v-list two-line subheader>
                  <v-list-tile avatar>
                    <v-list-tile-avatar :color="color">
                      <span class="white--text">{{spoil.name[0].toUpperCase()}}</span>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{spoil.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{pageName}} ID: {{spoil.id}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs6>
                <v-list subheader>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon>mail</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{spoil.contactEmail}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon>phone</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{spoil.contactPhone}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </layout-no-padding>

            <v-divider></v-divider>
          </v-card>
          <v-subheader class="pl-0">{{pageName}} Projects</v-subheader>
          <v-card>
            <layout-no-padding>
              <v-flex>
                <project-view :spoilId="spoil.id"></project-view>
              </v-flex>
            </layout-no-padding>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!--EDIT DIALOG -->
    <v-dialog v-model="edit" max-width="700px">
      <edit-spoil :spoil="spoil" @close="edit = false" @spoilEdited="displaySnack"></edit-spoil>
    </v-dialog>

    <snack-bar></snack-bar>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DisplaySnack from "@/services/mixins/displaySnack";
import EditSpoil from "@/components/spoils/editSpoil";
import ProjectView from "@/components/projects/projectView";
export default {
  mixins: [DisplaySnack],
  components: {
    EditSpoil,
    ProjectView
  },
  data() {
    return {
      pageName: "Spoil",
      edit: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  props: {
    spoil: Object,
    color: String
  }
};
</script>

<style>
</style>
